/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjEzMzk2IDExLjVMMi43MzMwNyAxNS42NTg1TDEuMDAxMDIgMTQuNjU4NUwyLjgyNDU2IDExLjVIMFY5LjVIMy45NzkyNkw1LjcxMTMxIDYuNUgwVjQuNUg2Ljg2NjAxTDkuMjY2OTMgMC4zNDE0OTJMMTAuOTk5IDEuMzQxNDlMOS4xNzU0MSA0LjVIMTJWNi41SDguMDIwNzFMNi4yODg2NiA5LjVIMTJWMTEuNUg1LjEzMzk2WiIgZmlsbD0iaW5oZXJpdCIvPg==";